var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "content header-global"
  }, [_c('ul', {
    staticClass: "left"
  }, [_c('li', {
    on: {
      "click": function ($event) {
        return _vm.handleHeaderTabClick('/');
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://image.kilimall.com/seller/kili_logo.png",
      "alt": "perfeelogo"
    }
  })]), _vm._v(" "), /create-seller-account/.test(_vm.$route.path) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.$store.state.locale === 'en' ? 'https://www.kilimall.co.ke/help-center/oh_3625?c_id=1149&s_id=1006&bs_type=2' : 'https://www.kilimall.co.ke/help-center/oh_3597?c_id=1119&s_id=1003&bs_type=2',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('nav.helpCenter')))])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "right"
  }, [_c('li', {
    staticClass: "language"
  }, [_c('LocalSet')], 1), _vm._v(" "), !_vm.$store.state.isLogin ? _c('li', {
    on: {
      "click": function ($event) {
        return _vm.handleHeaderTabClick('/create-seller-account/entry');
      }
    }
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.$t('nav.openMerchants')) + "\n        ")])]) : _vm._e(), _vm._v(" "), !_vm.$store.state.isLogin ? _c('li', {
    on: {
      "click": function ($event) {
        return _vm.handleHeaderTabClick('/login');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('nav.login')) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.$store.state.isLogin ? _c('li', {
    staticClass: "userName tc"
  }, [_c('img', {
    staticClass: "userIcon",
    attrs: {
      "src": require("assets/img/header/user.png"),
      "alt": "user"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$store.state.userName) + "\n        "), _c('ul', [_c('li', {
    on: {
      "click": _vm.toAdmin
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('nav.sellerCenter')) + "\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('nav.logOut')) + "\n          ")])])]) : _vm._e()])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }